exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.md-scrollbar ul.md-list {\n  background: #212121 !important;\n}\n", ""]);

// exports
